<template>
  <v-card class="elevation-0" outlined>
    <v-card-title style="line-height:.2rem">{{ $t('autoHedge.monteCarlo.title') }}</v-card-title>
    <v-card-text style="line-height: 1.7rem">
      <p style="font-size: 0.9rem;" >{{ $t('autoHedge.monteCarlo.lastSim') }}</p>
      <div class="d-flex justify-space-between">
        <div>
          <h4>{{ $t('autoHedge.monteCarlo.var99') }}</h4>
          <h2 style="color: #ff4444">-$465.2K</h2>
        </div>
        <div style="text-align: right">
          <h4>{{ $t('autoHedge.monteCarlo.cvar') }}</h4>
          <h2 style="color: #ff4444">-$672.8K</h2>
        </div>
      </div>
      <div class="d-flex justify-space-between">
        <div>
          <h4>{{ $t('autoHedge.monteCarlo.worstPathPnl') }}</h4>
          <h2 style="color: #ff4444">-$2.23M</h2>
        </div>
        <div style="text-align: right">
          <h4>{{ $t('autoHedge.monteCarlo.breakProbability') }}</h4>
          <h2 style="color: #ff8800">12.4%</h2>
        </div>
      </div>
      <div>
        <div class="risk-gauge">
          <div class="gauge-indicator" :style="{ left: gaugePos }"></div>
        </div>

        <div class="mt-3">
          <a  style="color: #00ccff" class="run-now-link" @click="runMonteCarlo">{{ $t('autoHedge.monteCarlo.runNow') }}</a>
          <span class="metric-label">{{ $t('autoHedge.monteCarlo.throttled') }}</span>
        </div>
      </div>
    </v-card-text>

    <OffsetModal :entry="entry" v-model="showModal" isOffset="MonteCarlo"/>
  </v-card>
</template>

<script>
import OffsetModal from '../../modal/OffsetModal.vue';

export default {
  components:{OffsetModal},
  data() {
    return {
      entry:null,
      showModal:false,
      var99: -456200,
      cvar: -672800,
      worstPathPnL: -1230000,
      currentExposureUSD: -2.4,
    };
  },
  mounted() {
    setInterval(() => {
      this.runMonteCarloSimulation();
    }, 3000);
  },
  methods: {
    runMonteCarloSimulation() {
      // Update Monte Carlo metrics based on current net exposure
      const absExposure = Math.abs(this.currentExposureUSD);
      const volatility = 0.08; // 8% annual volatility

      // Calculate VaR based on current exposure
      this.var99 = (absExposure * volatility * 2.33) / Math.sqrt(252); // Daily 99% VaR
      this.cvar = this.var99 * 1.25; // CVaR typically 25% higher than VaR
      this.worstPathPnL = this.var99 * 1.8; // Worst path scenario
      const breachProb = Math.min(15 + absExposure / 10, 35); // Breach probability increases with exposure
    },
    runMonteCarlo()
    {
      this.showModal=true
      this.entry = {action: this.$t('autoHedge.monteCarlo.simCompleted', { exposure: this.currentExposureUSD.toFixed(1) })
    }}
  },
  computed: {
    gaugePos() {
      const absExposure = Math.abs(this.currentExposureUSD);
      const breachProb = Math.min(15 + absExposure / 10, 35);
      return Math.min(breachProb * 2, 95) + "%";
    },
  },
};
</script>

<style scoped>
.v-application p {
  margin-bottom: 11px;
}
.gauge-indicator {
  position: absolute;
  top: -2px;
  width: 4px;
  height: 24px;
  background-color: white;
  border-radius: 2px;
  left: 75%;
}
.risk-gauge {
  height: 15px;
  background: linear-gradient(
    90deg,
    #00ff88 0% 60%,
    #ff8800 60% 85%,
    #ff4444 85% 100%
  );
  border-radius: 10px;
  position: relative;
  margin: 8px 0;
}
</style>
